module.exports = __webpack_public_path__ + "img/o-confirm-button.1fd18db8.png";